<mbs-switcher
  [selected]="isAutoRenewValue()"
  [disabledSelf]="disabled()"
  (beforeUpdate)="beforeAutoRenewChange($event)">
</mbs-switcher>
